export enum DeviceSize {
    none = 0,
    mobile = 320,
    mobileL = 425,
    tablet = 640,
    tabletL = 768,
    laptop = 1024,
    laptopL = 1440,
    desktop = 2560
}

export const Device = {
    mobile: `(min-width: ${DeviceSize.mobile})px`,
    mobileL: `(min-width: ${DeviceSize.mobileL}px)`,
    tablet: `(min-width: ${DeviceSize.mobileL}px)`,
    tabletL: `(min-width: ${DeviceSize.tablet}px)`,
    laptop: `(min-width: ${DeviceSize.laptop}px)`,
    laptopL: `(min-width: ${DeviceSize.laptopL}px)`,
    desktop: `(min-width: ${DeviceSize.desktop}px)`,
    desktopL: `(min-width: ${DeviceSize.desktop}px)`
};
